import React, { useEffect } from 'react';

export default function RenderTest() {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'module'; // Mark as ES module
    script.src = '/src/myscript.js'; // Adjust the path if needed
    script.async = true;
    script.onload = () => {
      if (window.init) {
        window.init(); // Call the init function if it's available globally
      }
    };
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script); // Clean up script on unmount
    };
  }, []);

  return (
    <div>
      <h1>Library Book Management</h1>
    </div>
  );
}
